export const MAP_BOUNDS_UPDATED = 'MAP_BOUNDS_UPDATED';
export const MAP_VISIBILITY_UPDATED = 'MAP_VISIBILITY_UPDATED';

const mapBoundsUpdated = (newMapBounds, event) => {
  return (dispatch) => {
    dispatch({
      type: MAP_BOUNDS_UPDATED,
      newMapBounds,
      event
    });
  };
};

const mapVisibilityUpdated = (newVisibility) => {
  return (dispatch) => {
    dispatch({
      type: MAP_VISIBILITY_UPDATED,
      newVisibility
    });
  };
};

export { mapBoundsUpdated, mapVisibilityUpdated };
